import { create } from "zustand";

export interface SpaceSelectionState {
  // Whether the user is currently selecting a space for AI
  isSelectingSpaceForAI: boolean;
  // Whether drag-select mode is active
  isDragSelectActive: boolean;
  // The selected space data (set when a space is clicked)
  spaceSelectedForAI: {
    spaceNumber: string;
    planName: string;
    propertyName: string;
  } | null;
  // Actions
  startSelectingSpaceForAI: () => void;
  stopSelectingSpaceForAI: () => void;
  setSpaceSelectedForAI: (
    data: {
      spaceNumber: string;
      planName: string;
      propertyName: string;
    } | null
  ) => void;
  // Drag select actions
  startDragSelect: () => void;
  stopDragSelect: () => void;
}

export const useSpaceSelectionStore = create<SpaceSelectionState>()((set) => ({
  isSelectingSpaceForAI: false,
  isDragSelectActive: false,
  spaceSelectedForAI: null,

  startSelectingSpaceForAI: () => {
    console.log("[SpaceSelectionStore] Starting space selection mode");
    set({ isSelectingSpaceForAI: true, spaceSelectedForAI: null });
  },

  stopSelectingSpaceForAI: () => {
    console.log("[SpaceSelectionStore] Stopping space selection mode");
    set({ isSelectingSpaceForAI: false });
  },

  setSpaceSelectedForAI: (data) => {
    console.log("[SpaceSelectionStore] Space selected:", data);
    set({ spaceSelectedForAI: data, isSelectingSpaceForAI: false });
  },

  startDragSelect: () => {
    console.log("[SpaceSelectionStore] Starting drag select mode");
    set({ isDragSelectActive: true });
  },

  stopDragSelect: () => {
    console.log("[SpaceSelectionStore] Stopping drag select mode");
    set({ isDragSelectActive: false });
  },
}));
